import styled from "styled-components";

export const Header = styled.div`
  min-height: 6.4rem;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1.6rem 2rem;
  background-color: #3439a5;
  color: #fff;
  font-size: 2rem;
  font-weight: 500;

  @media (min-width: 768px) {
    padding: 1.8rem 3.2rem;
    font-size: 2.2rem;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 2.4rem 1.6rem;

  @media (min-width: 768px) {
    padding: 3.2rem 2.4rem;
  }
`;

export const Button = styled.button`
  padding: 1.6rem 0rem;
  border-radius: 0.8rem;
  background-color: #3439a5;
  border: 0.1rem solid #2b2fa3;

  label {
    color: #fff;
    font-size: 1.6rem;
    font-weight: bold;
  }
`;
